import { Link, useParams } from "react-router";
import { PackageCheck } from "lucide-react";

/**
 * Carton and batch QRs (D-20) open `/k/` and `/b/` links. They move stock and
 * carry no points, so a phone camera that opens one lands here, not on a claim.
 */
export function PackingLabelPage() {
  const { orgSlug } = useParams();
  return (
    <main className="grid min-h-dvh place-items-center bg-surface px-4">
      <div className="w-full max-w-sm rounded-lg border border-rule bg-raised p-6 text-center shadow-card">
        <span className="mx-auto grid size-12 place-items-center rounded-full bg-brand-light text-brand-ink">
          <PackageCheck aria-hidden="true" className="size-6" />
        </span>
        <h1 className="mt-4 font-title text-lg font-semibold text-ink">This is a packing label</h1>
        <p className="mt-2 text-sm text-muted">
          It is used to move stock between shops. Scan the QR on the product itself to earn points.
        </p>
        <p className="mt-1 text-sm text-muted">यह पैकिंग लेबल है। पॉइंट के लिए प्रोडक्ट पर लगा QR स्कैन करें।</p>
        <Link
          className="mt-5 inline-flex h-10 items-center justify-center rounded-md bg-brand px-4 text-sm font-medium text-on-brand hover:bg-brand-hover"
          to={`/${orgSlug ?? ""}/karigar`}
        >
          Open the app
        </Link>
      </div>
    </main>
  );
}
